import Head from 'next/head'
import { plainToInstance } from 'class-transformer'

import { Container } from '@components/Container'
import { ContainerStoryCard } from '@components/ContainerStoryCard'
import { StoryCard } from '@components/StoryCard'
import { RecommendCatagoryType } from '@models/category/RecommendCatagoryType'
import { useDrawer } from '@hooks/contexts/DrawerContext/DrawerContext'
import { StoryDetailReaderType } from '@models/story/StoryDetailReaderType'
import { RecommendPageProps } from './interface'

export function RecommendPage({
  data,
  total,
  handleLikeBook,
  isLoadingToggleBookLike,
  isLoading,
}: RecommendPageProps) {
  const storyDrawer = useDrawer({ drawer: 'story' })

  return (
    <Container className='tablet-mobile:px-[20px] desktop-tablet:pt-[30px]'>
      <Head>
        <title>
          MaReads มารี้ด | อ่านเลย! นิยายออนไลน์ นิยายแปลเรื่องดัง และการ์ตูนฮิต
          แนะนำสำหรับคุณเท่านั้น
        </title>
      </Head>
      <ContainerStoryCard
        title='แนะนำสำหรับคุณ'
        total={total}
        isLoading={isLoading}
      >
        {data?.map((item: RecommendCatagoryType) => (
          <StoryCard
            key={item.id}
            id={item.id}
            title={item.title}
            isShowBookPromotion={item.hasSalePromotions}
            buyAllChaptersPromotion={item.buyAllChaptersPromotion}
            bookChapterCampaignHeader={item.bookChapterCampaignHeader}
            readFreePromotion={item.readFreePromotion}
            bookBadges={item.bookBadges}
            imageUrl={item.coverResizeImgPath || item.coverImgPath}
            penName={item.penName?.firstPenName}
            slug={item.penName?.user?.profilePageSlug}
            content={item.cover}
            category={item.category?.name}
            tags={item.tags}
            chapter={item.chapterCount}
            view={item.viewCount}
            chat={item.commentCount}
            like={item.likeCount}
            isLiked={item.isLiked}
            isEnded={item.isEnded}
            bookType={item.bookType}
            categoryId={item.category?.id}
            isToggleBookLike={isLoadingToggleBookLike}
            handleLikeBook={handleLikeBook}
            handleClickStoryCard={() => {
              storyDrawer.show({
                bookId: item.id,
                initialData: plainToInstance(StoryDetailReaderType, {
                  id: item.id,
                  coverImgPath: item.coverImgPath,
                  title: item.title,
                  writingType: item.writingType,
                  publishedAt: item.publishedAt,
                  cover: item.cover,
                  viewCount: item.viewCount,
                  commentCount: item.commentCount,
                  likeCount: item.likeCount,
                  publishedChapterCount: item.chapterCount,
                  penName: item.penName,
                  category: item.category,
                  bookType: item.bookType,
                  tags: item.tags,
                  rating: item.rating,
                  isEnded: item.isEnded,
                  isEpub: item.isEpub,
                  isPdf: item.isPdf,
                  isLiked: item.isLiked,
                }),
              })
            }}
          />
        ))}
      </ContainerStoryCard>
    </Container>
  )
}
